import { useLogout, useMe } from '../api/queries';

export function Header({ anchor }: { anchor?: string | undefined }) {
  const me = useMe();
  const logout = useLogout();
  return (
    <header className="top">
      <div className="top-in">
        <h1>Streaming Analysis Framework</h1>
        <div className="src">
          replicates <code>30. Data framework / Streaming Analysis.xlsx</code>
        </div>
        <div className="stamp">
          Luminate · anchor <b>{anchor ?? '—'}</b>
        </div>
        <div className="userbox">
          {me.data ? (
            <>
              <span>
                <b>{me.data.data.name ?? me.data.data.upn}</b> · {me.data.data.role}
              </span>
              <button type="button" onClick={() => logout.mutate()} disabled={logout.isPending}>
                Sign out
              </button>
            </>
          ) : null}
        </div>
      </div>
    </header>
  );
}
